import { defineMessages, type MessageDescriptor } from 'react-intl';

export const reviewButtonMessages: { reviewSuggestionsLabel: MessageDescriptor } = defineMessages({
	reviewSuggestionsLabel: {
		id: 'object-sidebar-components.review-suggestions.button.label',
		defaultMessage: 'Review suggestions',
		description:
			'Tooltip and accessible label for the review icon button in the object sidebar that opens AI suggested edits for the page',
	},
});
